import appendElements from "../../utils/appendElements";
import convertToDomNode from "../../utils/convertToDomNode";
import pipe from "../../lib/core/functional/pipe";
import queryDOM from "../../utils/queryDOM";
import tap from "../../lib/core/functional/tap";

const wrap = (menuItems) => {
    const wrapper = convertToDomNode(
        `<div class="user-prefs">
            <div class="hover-menu-options"></div>
        </div>`
    );
    return pipe(
        queryDOM(".hover-menu-options"),
        tap(appendElements(menuItems.map((m) => m.html))),
        tap(() => wrapper)
    )(wrapper);
};

export default wrap;
